import React, { Component } from "react";
import { BrowserRouter } from "react-router-dom";
import { sessionService } from "redux-react-session";
import { Provider } from "react-redux";
import configureStore from "./store/configure-store";
import "./index.css";
import App from "./App";
const store = configureStore();

class Root extends Component {
	constructor(props) {
		super(props);
		this.state = {
			token: "",
			firebaseToken: "",
			email: "",
			rol: ""
		};
	}

	componentWillMount() {
		const options = {
			refreshOnCheckAuth: true,
			redirectPath: "/login",
			driver: "COOKIES"
		};
		sessionService.initSessionService(store, options);
		sessionService
			.loadSession()
			.then(currentSession => {
				this.setState({
					token: currentSession.token,
					firebaseToken: currentSession.token
				});
			})
			.catch(err => {
				this.setState({ token: "no logged" }); //estos strings deberían ir en un archivo
			});
	}

	renderConditional(active) {
		if (!active) {
			return (
				<App
					token={this.state.token}
					firebaseToken={this.state.firebaseToken}
				/>
			);
		} else {
			return <div />;
		}
	}
	render() {
		let active = this.state.token === "";
		return (
			<Provider store={store}>
				<BrowserRouter>{this.renderConditional(active)}</BrowserRouter>
			</Provider>
		);
	}
}

export default Root;



// WEBPACK FOOTER //
// ./src/Root.js